import { Box, Grid } from '@material-ui/core';
import SkeletonWave from './SkeletonWave';

const TablePodcastSkeletonLoader = () => {
  return (
    <Box mt={2}>
      {Array.from({ length: 10 }, (_, index) => (
        <Box
          key={index}
          style={{
            marginTop: '2px',
            backgroundColor: '#28313b',
            padding: '10px'
          }}
        >
          <Grid container spacing={2} direction="row">
            <Grid item>
              <SkeletonWave height={60} width={60} backgroundColor="#364250" />
            </Grid>
            <Grid item>
              <Grid
                container
                justifyContent="space-between"
                direction="column"
                style={{ height: '100%' }}
              >
                <SkeletonWave
                  height={20}
                  width={200}
                  backgroundColor="#364250"
                />
                <SkeletonWave
                  height={8}
                  width={150}
                  backgroundColor="#364250"
                />
                <SkeletonWave
                  height={10}
                  width={400}
                  backgroundColor="#364250"
                />
                <SkeletonWave
                  height={10}
                  width={400}
                  backgroundColor="#364250"
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default TablePodcastSkeletonLoader;
